import React from "react";
import { Alert, Box, Button, Container, Typography } from "@mui/material";
import BannerSlider from "./slider/BannerSlider";
import RegFooter from "./RegFooter";
import useTemplateSettings from "../../hooks/useTemplateSettings";
import { useNavigate, useParams } from "react-router-dom";
import MuPb from "../../widgets/MuPb";
import SettingsIcon from "@mui/icons-material/Settings";
import { getErrorResponse } from "../../utils/util";
import BackBtn from "../../widgets/BackBtn";

const RegTemplates = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, isError, error } = useTemplateSettings(id);
  const templateSettings = data?.properties || {};

  if (isLoading) return <MuPb />;
  if (isError) return <Alert severity="error">{getErrorResponse(error)}</Alert>;

  return (
    <Box
      sx={{
        backgroundColor: "rgb(237, 241, 242)",
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflowX: "hidden",
      }}
    >
      {/* Absolute Background Header */}
      <Box
        sx={{
          width: "100%",
          height: { xs: "150px", sm: "200px", md: "300px" },
          top: 0,
          left: 0,
          position: "absolute",
          backgroundImage: `url(${templateSettings.haderBg})`, // Note: Check if 'haderBg' is a typo in your database/schema
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          zIndex: 0,
        }}
      />

      {/* Main Foreground Content */}
      <Box
        sx={{
          width: "100%",
          position: "relative",
          zIndex: 1,
          pb: 4,
        }}
      >
        <Container maxWidth="md">
          {/* BackBtn placed cleanly at the top-left */}
          <Box sx={{ pt: 2, pb: 1 }}>
            <BackBtn />
          </Box>

          {/* Only render the banner if the URL actually exists */}
          {templateSettings.headerBanner && (
            <img
              src={templateSettings.headerBanner}
              alt="Main Header"
              style={{
                width: "100%",
                borderRadius: "4px",
                height: "auto",
                marginBottom: "20px",
              }}
            />
          )}

          <BannerSlider ADS={templateSettings?.headerSliders ?? []} />

          {/* Handled responsiveness directly via MUI's sx prop */}
          <Typography
            component="h2"
            align="center"
            fontWeight={600}
            my={3}
            sx={{
              color: "#E60008",
              typography: { xs: "h6", sm: "h5", md: "h4" },
            }}
          >
            {data?.formTitle}
          </Typography>

          <Box
            my={2}
            height="192px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              backgroundColor: "primary.light",
              borderRadius: 2,
              boxShadow: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`/template-settings/${id}`)}
              startIcon={<SettingsIcon />}
            >
              Update Template Setting
            </Button>
          </Box>
        </Container>

        <RegFooter templateSettings={templateSettings} />
      </Box>
    </Box>
  );
};

export default RegTemplates;
